import axios from 'axios'
import { stringify } from 'qs'
import { getWhoAmI } from '../common/auth/authActions'
import { store } from '../index'
import apiUrl from './apiUrl'
import { Preferences } from '@capacitor/preferences'
import { INotification } from '../common/notifications/NotificationReducers'
import { t } from 'ttag'
import { addNotification } from '../common/notifications/NotificationActions'

const ApiClient = axios.create({
  baseURL: apiUrl('/rpc'),
  paramsSerializer: (params) => stringify(params, { arrayFormat: 'repeat' }),
  timeout: 100000,
  // Don't send any cookies with requests.
  withCredentials: false,
})

ApiClient.interceptors.request.use(
  async (config) => {
    const { value: session } = await Preferences.get({ key: 'session' })
    if (session && session != 'undefined') {
      config.headers.set('Authorization', `Bearer ${session}`)
    }
    return config
  },
  (error) => Promise.reject(error),
)

ApiClient.interceptors.response.use(
  (response) => {
    /**
     * If response header has 'content-disposition' return full response with headers.
     * 'content-disposition' is only returned on file download.
     */
    const contentDisposition = response.headers && response.headers['content-disposition']
    if (contentDisposition) {
      return response
    }

    return response.data
  },
  (error) => {
    const { response } = error
    const { data } = response || { data: { message: 'No message has been provided by the server' } }
    const { message } = data || { message: 'No message has been provided by the server' }
    console.log('RequestFailed', error)

    // Rate-limited.
    if (data?.status === 429) {
      const notification: INotification = {
        type: 'warning',
        // This doesn't auto-translate very well...
        content: `Rate limit exceeded!`,
      }
      store.dispatch(addNotification(notification))
    } else {
      const UNAUTHORIZED_ACTION = 'Unauthorized action'
      if (message === UNAUTHORIZED_ACTION) {
        store.dispatch(getWhoAmI())
      }
    }

    // Needed for proper messages to clients
    return Promise.reject({ error: error, message: message, status: response ? response.status : -1 })
  },
)

export default ApiClient
